export default __webpack_public_path__ + "static/media/feather.ba142c9a.eot";